<template>
  <div class="animated fadeIn reports">
    <b-card no-body>
      <b-row>
        <b-col lg="12">
          <b-card no-body class="bg-white">
            <b-row slot="header" class="p-0" >
              <b-col sm="3" class="mt-auto">
                <h5> Forms Report</h5>
              </b-col>
              <b-col sm="1.5" class="mt-auto">
                <h6> {{ $t('COMMON.DATE_RANGE') }} </h6>
              </b-col>
              <b-col sm="3" class="mt-auto">
                <date-picker range v-model="formsDateRange" lang="en" format="YYYY-MM-DD" append-to-body :clearable="false" width="220px"></date-picker>
              </b-col>
              <b-col sm="1"  class="mt-auto">
                <b-button v-on:click="fetchFormStatusReports">Fetch</b-button>
              </b-col>
            </b-row>
            <b-card-body>
              <b-row>
                <b-col md='12' lg='12'>
                  <router-link :to="{ path: '/process/processed'}">
                    <b-card no-body class="dash-box">
                      <b-card-body class="pb-6">
                        <b-row class="dash-row">
                          <b-col cols="10">
                            <h1 class="mb-0">Processed Forms</h1>
                            <div class="process-datas">
                              <div v-for="(count, processed) in processedFormsCounts">
                                <div class="process-data" v-if="processedFormsStatus.includes(processed)" >
                                  <h4 :class="'processed-' + processed"><animated-number :value="count || 0" :formatValue="formatNumber" :duration="1500"/></h4>
                                  <h3 class> {{ $t('COMMON.'+processed.toUpperCase()) }} </h3>
                                </div>
                              </div>
                            </div>
                          </b-col>
                          <b-col cols="2">
                            <div v-html="svg.forms"></div>
                          </b-col>
                        </b-row>
                      </b-card-body>
                    </b-card>
                  </router-link>
                </b-col>
              </b-row>

              <b-row>
                <b-col md='12' lg='12'>
                  <router-link :to="{ path: '/process/processed'}">
                    <b-card no-body class="dash-box">
                      <b-card-body class="pb-6">
                        <b-row class="dash-row">
                          <b-col cols="10">
                            <h1 class="mb-0">Triage Forms</h1>
                            <div class="process-datas">
                              <div v-for="(count, processed) in triageFormsCounts">
                              <div class="process-data" v-if="triagedFormsStatus.includes(processed)" >
                                <h4 :class="'processed-' + processed"><animated-number :value="count || 0" :formatValue="formatNumber" :duration="1500"/></h4>
                                <h3 class> {{ $t('COMMON.'+processed.toUpperCase()) }} </h3>
                              </div>
                              </div>
                            </div>
                          </b-col>
                          <b-col cols="2">
                            <div v-html="svg.forms"></div>
                          </b-col>
                        </b-row>
                      </b-card-body>
                    </b-card>
                  </router-link>
                </b-col>
              </b-row>

              <b-row>
                <b-col md='12' lg='12'>
                  <router-link :to="{ path: '/process/processed'}">
                    <b-card no-body class="dash-box">
                      <b-card-body class="pb-6">
                        <b-row class="dash-row">
                          <b-col cols="10">
                            <h1 class="mb-0">Unmatched Forms</h1>
                            <div class="process-datas">
                              <div  v-for="(count, processed) in unmatchedFormsCounts">
                                <div class="process-data" v-if="unmatchedFormsStatus.includes(processed)">
                                  <h4 :class="'processed-' + processed"><animated-number :value="count || 0" :formatValue="formatNumber" :duration="1500"/></h4>
                                  <h3 class> {{ $t('COMMON.'+processed.toUpperCase()) }} </h3>
                                </div>
                              </div>
                            </div>
                          </b-col>
                          <b-col cols="2">
                            <div v-html="svg.forms"></div>
                          </b-col>
                        </b-row>
                      </b-card-body>
                    </b-card>
                  </router-link>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <div id="recent-forms">
        <b-card no-body bg-variant="light" class="received-form">
          <b-row slot="header" class="p-0">
            <b-col sm="3" class="mt-auto">
              <h5>{{ $t('ANALYTICS.FORMS_INSIGHTS') }}</h5>
            </b-col>
            <b-col sm="1.5" class="mt-auto">
              <h6> {{ $t('COMMON.DATE_RANGE') }} </h6>
            </b-col>
            <b-col sm="4" class="mt-auto">
              <date-picker range v-model="dateRange" lang="en" format="YYYY-MM-DD" append-to-body :clearable="false" width="220px"></date-picker>
            </b-col>
            <b-col sm="1"  class="mt-auto">
              <b-button v-on:click="fetchProcessedForms">Fetch</b-button>
            </b-col>
            <b-col sm="2"  class="mt-auto">
              <b-button v-on:click="downloadFormsInsights">Download</b-button>
            </b-col>
          </b-row>
          <div class="report-table">
            <b-table show-empty striped :empty-text="$t('COMMON.NO_RECORD')" hover responsive="sm" variant="danger" v-if="showProcessedForms" :items="dailyReports" :fields="tableFields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
              <template slot="HEAD_title" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
              <template slot="HEAD_username" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
              <template slot="HEAD_total_page_count" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
              <template slot="HEAD_average_confidence" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
              <template slot="HEAD_total_fields" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
              <template slot="HEAD_transcribed_fields" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
              <template slot="HEAD_accuracy_percentage" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
              <template slot="HEAD_edited_fields" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
              <template slot="HEAD_status" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
              <template slot="HEAD_created_at" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
              <template slot="HEAD_updated_at" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
              <template slot="HEAD_document_recieved_at" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
              <template slot="HEAD_time_difference" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
            </b-table>
            <content-placeholders v-else >
              <content-placeholders-text :lines="12"/>
            </content-placeholders>
            <infinite-loading
              :distance="distance"
              spinner="spiral"
              @infinite="dailyReportsInfinetHandler"
              ref="infiniteLoading">
                <div slot="no-more"></div>
                <div slot="no-results"></div>
            </infinite-loading>
          </div>
        </b-card>
      </div>
    </b-card>
  </div>
</template>

<script>
import Vue from 'vue'
import router from '../../router'
import AnimatedNumber from 'animated-number-vue'
import { mapGetters } from 'vuex'
import DatePicker from 'vue2-datepicker'
import InfiniteLoading from 'vue-infinite-loading'
import moment from 'moment'
import svg from '../../_svg.js'

export default {
  name: 'reports-form',
  data () {
    return {
      processedForms: [],
      distance: Infinity,
      lastFormId: -1,
      sortBy: 'id',
      sortDesc: true,
      showProcessedForms: false,
      tableFields: [
        { key: 'id', sortable: true },
        { key: 'title', label: 'WORKFLOW.TITLE', sortable: false },
        { key: 'username', lavel: 'COMMON.USERNAME', sortable: false },
        { key: 'total_page_count', label: 'ANALYTICS.PAGES', sortable: false },
        { key: 'average_confidence', label: 'ANALYTICS.CONFIDENCE', sortable: true },
        { key: 'total_fields', label: 'ANALYTICS.TOTAL_FIELDS', sortable: false },
        { key: 'transcribed_fields', label: 'ANALYTICS.TRANSCRIBED_FIELDS', sortable: false },
        { key: 'edited_fields', label: 'ANALYTICS.EDITED_FIELDS', sortable: false },
        { key: 'accuracy_percentage', label: 'ANALYTICS.ACCURACY_PERCENTAGE', sortable: false },
        { key: 'status', label: 'COMMON.STATUS', sortable: false },
        { key: 'created_at', label: 'WORKFLOW.CREATED_AT', sortable: false },
        { key: 'updated_at', label: 'WORKFLOW.UPDATED_AT', sortable: false },
        { key: 'document_recieved_at', label: 'WORKFLOW.DOC_RECIEVED_AT', sortable: false },
        { key: 'time_difference', label: 'WORKFLOW.TIME_DIFF', sortable: false }
      ],
      dateRange: [moment(), moment()],
      formsDateRange: [moment(), moment()],
      dailyReports: [],
      formsProcessed: [],
      svg: svg,
      processedFormsStatus: [
        'pending',
        'in_progress',
        'rejected',
        'recalled',
        'validated',
        'integration_success',
        'integration_failed',
        'document_moved_to_sf'
      ],
      triagedFormsStatus: [
        'new_doc',
        'in_progress',
        'partially_completed',
        'completed',
        'triaged',
        'recalled',
        'rejected',
        'integration_success',
        'integration_failed',
        'document_moved_to_sf'
      ],
      unmatchedFormsStatus: [
        'pending',
        'in_progress',
        'validated',
        'rejected',
        'recalled',
        'integration_success',
        'integration_failed',
        'document_moved_to_sf'
      ],
      processedFormsCounts: [],
      triageFormsCounts: [],
      unmatchedFormsCounts: []
    }
  },
  components: {
    'date-picker': DatePicker,
    AnimatedNumber,
    InfiniteLoading
  },
  computed: {
    ...mapGetters(['idToken', 'isAdminRole'])
  },
  created () {
    this.fetchFormStatusReports()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.isAdminRole) {
        next()
      } else {
        router.replace('/Not-Found-404')
      }
    })
  },
  methods: {
    formatNumber (value) {
      return value.toFixed(0)
    },
    fetchFormStatusReports () {
      let startDate = moment(this.formsDateRange[0]).format('YYYY-MM-DD')
      let endDate = moment(this.formsDateRange[1]).format('YYYY-MM-DD')
      let params = { start_date: startDate, end_date: endDate }
      Vue.axios.post('reports/forms_status_reports', params, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.processedFormsCounts = res.data.processed_forms
          this.triageFormsCounts = res.data.triage_forms
          this.unmatchedFormsCounts = res.data.unmatched_forms
        })
        .catch(error => {
          console.error(error)
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    fetchProcessedForms () {
      this.dailyReports = []
      this.distance = Infinity
      this.lastFormId = -1
      this.showProcessedForms = false
      this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
    },
    dailyReportsInfinetHandler ($state) {
      let payload = {
        last_form_id: this.lastFormId,
        start_date: moment(this.dateRange[0]).format('YYYY-MM-DD'),
        end_date: moment(this.dateRange[1]).format('YYYY-MM-DD')
      }
      Vue.axios.get('reports/daily_report', { headers: { Authorization: `Bearer ${this.idToken}` }, params: payload })
        .then(res => {
          let forms = res.data.forms_processed
          if (forms.length > 0) {
            this.distance = 100
            this.dailyReports = this.dailyReports.slice().concat(forms)
            this.lastFormId = forms[forms.length - 1]['id']
            this.formsProcessed = res.data.processed_by_agent_assist
            this.showProcessedForms = true
            this.sortBy = 'id'
            this.sortDesc = true
            $state.loaded()
          } else {
            this.distance = 100
            this.showProcessedForms = true
            $state.complete()
          }
        })
        .catch(error => {
          console.error(error)
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    downloadFormsInsights () {
      let payload = {
        start_date: moment(this.dateRange[0]).format('YYYY-MM-DD'),
        end_date: moment(this.dateRange[1]).format('YYYY-MM-DD')
      }
      let title = 'reports_'
      Vue.axios.post('reports/form_insights.csv', payload, { headers: { 'Authorization': `Bearer ${this.idToken}` } })
        .then(res => {
          let csvData = res.data
          var downloadLink = document.createElement('a')
          downloadLink.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData)
          downloadLink.download = title + '_' + moment().format() + '.csv'
          document.body.appendChild(downloadLink)
          downloadLink.click()
          downloadLink.remove()
        })
        .catch(error => {
          console.error(error)
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.reports {
  .card {
    .dash-box:hover {
      background: #0e2547 !important;;
    }
    cursor: pointer;
    background: #ebeef3;
    border-radius: 10px;
    .bar {
      width: 100%;
      height: 10px;
      border-radius: 10px 10px 0 0;
    }

    .card-header {
      border-radius: 10px 10px 0 0;
      background-color: #e7e7e7;
      padding: 1rem;
    }
  }

  select {
    border-radius: 6px;
  }

  .group-by {
    margin-top: 13px;
  }

  .custom-select {
    background: #fff;
    padding: 0.5rem;
  }

  .top-layer {
    justify-content: space-between;
    padding: 0 1.25em;
  }

  .report-table {
    max-height: 26.5rem;
    overflow-y: scroll;
    border-radius: 0 0 10px 10px;
  }

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }

  ::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0,0,0,.5);
      -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
  }
}

.stats-unmatched{
  padding-bottom: 0;
}

.eq-height {
  border: none;
  border-radius: 2px;
  box-shadow: 0px 2px 3px 2px, rgba(0,0,0,0.03)
}

#filterBy {
  width: 220px;
}
#teamFilter {
  padding-bottom: 6px;
}
</style>
<style>

  .stats-pending .timeline-circle {
    background-color: #20a8d8;
  }

  .stats-unmatched .timeline-circle {
    background-color: #f86c6b;
  }

  .stats-accepted .timeline-circle {
    background-color: #4dbd74;
  }

  .stats-verified .timeline-circle {
    background-color: orange;
  }
</style>



// WEBPACK FOOTER //
// src/views/reports/formsInsights.vue